const router = [
  {
    name: 'system',
    path: '/system',
    meta: {
      title: '系统管理',
      icon: 'shezhi'
    }
  },
  {
    name: 'systemConfig',
    path: '/system/config',
    component: () => import('/@/views/system/Config.vue'),
    meta: { title: '系统设置' }
  },
  {
    name: 'systemAccount',
    path: '/system/account',
    component: () => import('/@/views/system/Account.vue'),
    meta: { title: '账号管理' }
  },
  {
    name: 'systemRole',
    path: '/system/role',
    component: () => import('/@/views/system/Role.vue'),
    meta: { title: '角色管理' }
  },
  {
    name: 'systemPermission',
    path: '/system/permission',
    component: () => import('/@/views/system/Permission.vue'),
    meta: { title: '菜单管理' }
  },
  {
    name: 'systemUpdate',
    path: '/system/update',
    component: () => import('/@/views/system/Update.vue'),
    meta: { title: '系统升级' }
  },
  {
    name: 'systemOper',
    path: '/system/oper',
    component: () => import('/@/views/system/Oper.vue'),
    meta: { title: '操作记录' }
  },
  {
    name: 'systemAppCenter',
    path: '/system/app',
    component: () => import('/@/views/system/AppCenter.vue'),
    meta: { title: '应用中心' }
  },
  {
    name: 'systemDataBase',
    path: '/system/database',
    component: () => import('/@/views/system/Database.vue'),
    meta: { title: '数据备份' }
  },
  {
    name: 'systemNotice',
    path: '/system/notice',
    component: () => import('/@/views/system/Notice.vue'),
    meta: { title: '通知管理' }
  }

]
export default router
